export enum DisplayVariant {
  Variant1 = "VARIANT_1",
}
